export default __webpack_public_path__ + "static/media/stella.7e1c4cf3.jpg";